// loading.interceptor.ts
import {
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpEvent,
} from "@angular/common/http";
import { Observable, finalize, delay } from "rxjs";
import { inject } from "@angular/core";
import { LoadingService } from "../../services/loading/loading.service";
import { SKIP_LOADER_URLS } from "../../../../../public/assets/config/constants";

// Using the new functional interceptor approach for Angular standalone
export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(LoadingService);

  const skipLoaderUrls = SKIP_LOADER_URLS;

  const skipLoader = skipLoaderUrls.some((url) => req.url.includes(url));

  // Show loader only for non-skipped URLs
  if (!skipLoader) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      // Hide loader once the request completes
      if (!skipLoader) {
        loadingService.hide();
      }
    })
  );
};
